// extracted by mini-css-extract-plugin
module.exports = {"img":"GiphyAttribution-img-560e9b6b49b60d338042de101514e745"};